/* eslint-disable @typescript-eslint/naming-convention */
import type { Panel } from '@ps/web-martech-cms-types';
import React, { useState } from 'react';

import styles from './CMSPanel.scss';
import PanelItem from './PanelItem';

const CMSPanel: React.FC<Panel> = ({ body, show_text, hide_text }) => {
  const [expanded, setExpanded] = useState(false);

  return body.length ? (
    <div className={styles.panel}>
      <PanelItem
        body={body}
        expanded={expanded}
        onClick={() => setExpanded((expanded) => !expanded)}
        expandedTitle={show_text}
        collapsedTitle={hide_text}
      />
    </div>
  ) : null;
};

export default CMSPanel;
